const state = {
  isActive: false,
  isUekEnabled: false,
  declarationId: null,
  declarationType: null,
};

const getters = {};

const actions = {
  openModal(
    { commit, state },
    {
      declarationId = null,
      declarationType = null,
      isUekEnabled = false,
    } = {},
  ) {
    commit('setIsActive', true);
    commit('setUekEnabled', isUekEnabled);
    commit('setDeclarationData', {
      declarationId,
      declarationType,
    });
  },

  closeModal({ commit, dispatch }) {
    commit('setIsActive', false);
    commit('setUekEnabled', false);
    dispatch('resetDeclarationData');
  },

  resetDeclarationData({ commit }) {
    commit('setDeclarationData', {
      declarationId: null,
      declarationType: null,
    });
  },
};

const mutations = {
  setIsActive(state, value) {
    state.isActive = !!value;
  },

  setDeclarationData(state,
                     {
                       declarationId = null,
                       declarationType = null,
                     },
  ) {
    state.declarationId = declarationId;
    state.declarationType = declarationType;
  },

  setUekEnabled(state, value) {
    state.isUekEnabled = !!value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
